import { useParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useSelector } from "react-redux";

const useProfileLinks = (overrideId = null) => {
  const { id: routeId } = useParams();
  const { userId, role } = useAuth();
  const profile = useSelector((state) => state.profile.data);

  // Determine correct ID depending on role
  const getCorrectId = () => {
    if (overrideId) return overrideId;
    if (routeId) return routeId;

    if (role === "freelancer" && profile?.freelancer_profile?.id) {
      return profile.freelancer_profile.id;
    }

    if (role === "business" && profile?.business_profile?.id) {
      return profile.business_profile.id;
    }

    // default → user
    return userId;
  };

  const finalId = getCorrectId();
  const isOwnProfile = String(userId) === String(finalId);

  // Determine base route depending on role
  const getRoleBase = () => {
    if (role === "freelancer") return "freelancer";
    if (role === "business") return "business";
    return "profile";
  };

  const roleBase = getRoleBase();

  const profileBase = `/${roleBase}/${finalId}`;

  return {
    isOwnProfile,
    profileBase,
    mediaBase: `${profileBase}/media`,
    jobsBase: `${profileBase}/jobs`,
    reviewsBase: `${profileBase}/reviews`,
    projectsBase: `${profileBase}/projects`,
  };
};

export default useProfileLinks;